import type { AdditionalText, Product } from 'models/product';

export function filterAdditionalTexts(
	texts: (AdditionalText | null | undefined)[] | undefined,
): AdditionalText[] {
	return (
		(texts ?? [])
			.filter((text) => text?.title || text?.textFormatted)
			// TypeScript is too dumb to figure out that text is defined without this
			// separate check, can't be done in the previous filter as of 5.6.
			.filter((text) => !!text)
	);
}

export function hasChemicalInformation(product: Product) {
	const info = product.chemicalInformationResponse;
	return Boolean(
		info?.hazardStatements ||
		info?.supplementalHazardStatements ||
		info?.precationaryStatements,
	);
}
